import { Component, OnInit, Output, EventEmitter, HostListener } from '@angular/core'; import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import moment from 'moment';
import { PersonalInfo } from 'src/app/models/personalInfo';
import { HealthCareProviderInfo } from 'src/app/models/healthCareProviderInfo';
import { EmploymentInfo } from 'src/app/models/employmentInfo';
import { PastEmployerInfo } from 'src/app/models/pastEmployerInfo';
import { Documents } from 'src/app/models/documets';
import { Claim } from 'src/app/models/claim';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { PrinterFooterComponent } from './printer-footer/printer-footer.component';
import { PrinterHeaderComponent } from './printer-header/printer-header.component';
import { PhonenumbersplitPipe } from '../../pipes/phonenumbersplit.pipe';
import { MY_FORMATS } from 'src/app/services/sharedHelper';

@Component({
  selector: 'app-print',
  templateUrl: './print.component.html',
  styleUrls: ['./print.component.css'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
  imports: [
    CommonModule,
    TranslateModule,
    PrinterFooterComponent,
    PrinterHeaderComponent,
    PhonenumbersplitPipe
  ],
  standalone: true
})


// This class is responsible for Disply user info , Health care info, Employment info and Supporting documents info
export class PrintComponent implements OnInit {

  public claimId: number;
  public referenceNumber: string;
  public personalInformation: PersonalInfo;
  public healthInfo: HealthCareProviderInfo;
  public employInfo: EmploymentInfo;
  public pastEmployInfo: PastEmployerInfo[];
  public claimDocumentsList: Documents[];
  public newclaimDocumentsList: [];
  public audiogramDocumentsList: [];
  @Output() localeChanged: EventEmitter<string> = new EventEmitter();

  constructor(private translateService: TranslateService, private httpClient: HttpClient) { }

  ngOnInit() {
    const lang = localStorage.getItem('currentLang');
    this.translateService.use(lang);
    this.localeChanged.emit(lang);
    this.getClaim();
  }

  formatDate(date: string): string {
    return moment(new Date(date)).format('YYYY-MM-DD');
  }

  /*
   * @author Deivid Mafra;
   * @date 08/24/2020;
   * @remarks Method responsible for retrieve data of an existing claim on localStorage.
   * @param claimId
   */
  getClaim = () => {

    const claim: Claim = localStorage.getItem('claimPrint') ? JSON.parse(localStorage.getItem('claimPrint')) : {};
    this.referenceNumber = claim.referenceNumber;
    this.personalInformation = claim.personalInformation;
    this.healthInfo = claim.healthCareProviderInformation;

    this.employInfo = claim.employmentInformation;

    this.pastEmployInfo = this.employInfo ? claim.employmentInformation.pastEmploymentInformationList.sort((a, b) => (a.employmentStartDate > b.employmentStartDate) ? -1 : 1) : null;

    this.newclaimDocumentsList = JSON.parse(localStorage.getItem('claimDocumentsList'));
    this.audiogramDocumentsList = JSON.parse(localStorage.getItem('audiogramDocumentsList'));


    this.claimDocumentsList = claim.claimDocumentsList;

    if (claim?.personalInformation && claim?.personalInformation.primaryTelephoneNumber) {
      const phone1splitted = this.personalInformation.primaryTelephoneNumber.split(' ');
      this.personalInformation.primaryTelephoneNumber = phone1splitted[1];
    }
    if (claim?.personalInformation && claim?.personalInformation.secondaryTelephoneNumber) {
      const phone2splitted = this.personalInformation.secondaryTelephoneNumber.split(' ');
      this.personalInformation.secondaryTelephoneNumber = phone2splitted[1];
    }

    if (claim?.employmentInformation && claim?.employmentInformation.currentEmployerPhoneNumber) {
      const retirementDate = this.employInfo.currentEmployerPhoneNumber.split(' ');
      this.employInfo.currentEmployerPhoneNumber = retirementDate[1];
    }

    /* format dates */
    if (claim.personalInformation && claim.personalInformation.dateOfBirth) {
      this.personalInformation.dateOfBirth = moment(this.personalInformation.dateOfBirth).format('YYYY-MM-DD');
    }
    if (claim.healthCareProviderInformation && claim.healthCareProviderInformation.dateOfFirstAudiogram) {
      this.healthInfo.dateOfFirstAudiogram = moment(this.healthInfo.dateOfFirstAudiogram).format('YYYY-MM-DD');
    }
    if (claim.healthCareProviderInformation && claim.healthCareProviderInformation.entAppointmentDate) {
      this.healthInfo.entAppointmentDate = moment(this.healthInfo.entAppointmentDate).format('YYYY-MM-DD');
    }
    if (claim.healthCareProviderInformation && claim.healthCareProviderInformation.hearingLossNoticedYear) {
      this.healthInfo.hearingLossNoticedYear = moment(this.healthInfo.hearingLossNoticedYear).format('YYYY');
    }
    if (claim.healthCareProviderInformation && claim.healthCareProviderInformation.hearingAidUsageDate) {
      this.healthInfo.hearingAidUsageDate = moment(this.healthInfo.hearingAidUsageDate).format('YYYY-MM-DD');
    }

  }

}
